module.exports = __webpack_public_path__ + "img/product_44.07878ea.webp";